var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg380SBulb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-94787ce6-3fc0-4bb2-86c6-eee8df3eaea4",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-0d726f6a-8c78-40c8-b102-163ec2255df2",
    "data-name": "art"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.2,24.55c-.28,0-.5-.22-.5-.5,0-2,1.04-3.18,2.04-4.33,1.11-1.26,2.26-2.57,2.26-5.17,0-3.31-2.69-6-6-6s-6,2.69-6,6c0,2.66,1.15,3.96,2.27,5.22,1,1.12,2.03,2.29,2.03,4.28,0,.28-.22.5-.5.5s-.5-.22-.5-.5c0-1.61-.82-2.54-1.78-3.62-1.18-1.33-2.52-2.84-2.52-5.88,0-3.86,3.14-7,7-7s7,3.14,7,7c0,2.97-1.33,4.49-2.5,5.83-.96,1.1-1.79,2.05-1.79,3.67,0,.28-.22.5-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.3,29.55h-2.6c-.81,0-1.3-.66-1.3-1.3v-.31c-.69-.1-1.1-.7-1.1-1.29v-1.5c0-.81.66-1.3,1.3-1.3h4.8c.81,0,1.3.66,1.3,1.3v1.5c0,.73-.53,1.2-1.1,1.29v.32c0,.81-.66,1.3-1.3,1.3Zm-3.7-4.7c-.12,0-.3.08-.3.3v1.5c0,.12.08.3.3.3h.3c.28,0,.5.22.5.5v.8c0,.12.08.3.3.3h2.6c.1,0,.3-.06.3-.3v-.8c0-.28.22-.5.5-.5h.3c.12,0,.3-.08.3-.3v-1.5c0-.12-.08-.3-.3-.3h-4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16,5.65c-.28,0-.5-.22-.5-.5v-2.9c0-.28.22-.5.5-.5s.5.22.5.5v2.9c0,.28-.22.5-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.3,9.15c-.13,0-.26-.05-.35-.15-.2-.2-.2-.51,0-.71l2.3-2.3c.2-.2.51-.2.71,0s.2.51,0,.71l-2.3,2.3c-.1.1-.23.15-.35.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.6,16.45h-3.3c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h3.3c.28,0,.5.22.5.5s-.22.5-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.3,24.85c-.13,0-.26-.05-.35-.15l-2.3-2.3c-.2-.2-.2-.51,0-.71s.51-.2.71,0l2.3,2.3c.2.2.2.51,0,.71-.1.1-.23.15-.35.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.7,24.85c-.13,0-.26-.05-.35-.15-.2-.2-.2-.51,0-.71l2.3-2.3c.2-.2.51-.2.71,0s.2.51,0,.71l-2.3,2.3c-.1.1-.23.15-.35.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.6,16.35h-3.3c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h3.3c.28,0,.5.22.5.5s-.22.5-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.6,9.05c-.13,0-.26-.05-.35-.15l-2.3-2.3c-.2-.2-.2-.51,0-.71s.51-.2.71,0l2.3,2.3c.2.2.2.51,0,.71-.1.1-.23.15-.35.15Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg380SBulb);
export default __webpack_public_path__ + "static/media/380S-bulb.fecc15e836453e627ebd0fabb74087dc.svg";
export { ForwardRef as ReactComponent };